import module from 'nominas/nomina/module.js'
import template from './template.html'

const catalogoMetodo = [
  {id: 1, descripcion: 'Importe máximo'},
  {id: 2, descripcion: 'Número de pagos'},
]

export class NominasNominaDispersionPagosDividirConfirmarComponent {
  idProyecto
  idNomina
  idTipoPago
  idMetodoPago
  idMoneda
  data
  omitidos
  onClose
  pagos = []
  error = null
  catalogo = {
    metodo: catalogoMetodo,
  }
  configuracion = {
    metodoId: 1,
    valor: null,
  }

  constructor (NominasNominaDispersionPagosDividirService) {
    this.NominasNominaDispersionPagosDividirService = NominasNominaDispersionPagosDividirService
  }

  $onChanges () {
    this.pagos = [].concat(this.data.map(item => ({
      idPago: +item.id,
      importe: +item.importe,
      resultados: [],
    })))
  }

  aceptar () {
    if (this.procesando) return
    this.procesando = true
    this.pagos.forEach((item) => (this.dividirPago(item)))

    let data = this.pagos.filter((item => item.resultados.length))

    this.NominasNominaDispersionPagosDividirService.put(this.idNomina, this.idProyecto, data)
      .then(({data}) => (this.pagos.map((pago) => Object.assign(pago, data.find((a) => a.idPago === pago.idPago)))))
      .then(() => (this.procesado = true))
      .catch((error) => (this.error = error.data || error))
      .finally(() => (this.procesando = false))
  }

  cancelar () {
    this.onClose({$event: {data: []}})
  }

  dividirPago (item) {
    let importe = this.configuracion.metodoId === 1 ? +this.configuracion.valor : +(item.importe / this.configuracion.valor).toFixed(2)
    let restante = item.importe

    if (item.importe < importe || importe < 1) return

    item.importe = importe

    restante = +(restante - importe).toFixed(2)
    while (restante !== 0) {
      importe = Math.min(restante, importe)
      item.resultados.push({importe: +importe.toFixed(2), observaciones: 'División de pago'})
      restante = +(restante - importe).toFixed(2)
    }
  }

  finalizar () {
    if (this.procesado) {
      this.onClose({$event: {data: this.pagos.map(item => ({id: item.idPago, importe: item.importe, resultados: item.resultados}))}})
    } else {
      this.cancelar()
    }
  }

}

module.component('nominasNominaDispersionPagosDividirConfirmar', {
  controller: NominasNominaDispersionPagosDividirConfirmarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    idTipoPago: '<',
    idMetodoPago: '<',
    idMoneda: '<',
    data: '<',
    omitidos: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/dividir/confirmar/component.js